
			
document.addEventListener("DOMContentLoaded", function() {

  const btn = document.querySelector(".bundle-work-popup-btn");
  const popup = document.querySelector(".bundle-rules-popup");
  const closeBtn = document.querySelector(".bundle-popup-close");

  if (btn && popup) {
    btn.addEventListener("click", function(e) {
      e.preventDefault();
      popup.classList.add("active");
    });
  }

  if (closeBtn && popup) {
    closeBtn.addEventListener("click", function() {
      popup.classList.remove("active");
    });
  }

});            
